// React
import { useTranslation } from "react-i18next";

// MUI
import {
  Typography,
  TextField,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Stack,
} from "@mui/material";

// Styles
import { styles } from "../styles";

// Utils
import { highlightWord } from "Utils/Reasons";
import { getTranslatedReason } from "Components/Appointments/Common";

export const LocationStep = ({
  showLocationStep,
  showReasonStep,
  hideReasonStep,
  location,
  reasonForVisit,
  locationOptions,
  sortedUniqueTypes,
  appointmentReasons,
  onLocationChange,
  onReasonForVisitChange,
}) => {
  const { t, i18n } = useTranslation();

  const highlightWords =
    t("highlightWords.words", {
      lng: i18n.language,
      returnObjects: true,
    }) || [];

  return (
    <>
      <Typography sx={styles.heading}>
        {t("reasonForVisitModal.selectLocation")}
      </Typography>
      {showLocationStep && (
        <TextField
          select
          value={location || ""}
          onChange={onLocationChange}
          variant="outlined"
          fullWidth
          label={t("reasonForVisitModal.locationLabel")}
          slotProps={{
            inputLabel: { required: true },
          }}
        >
          {locationOptions.map((item) => (
            <MenuItem
              key={item.location.en}
              value={item.location.en}
              sx={styles.menuItem}
            >
              {item.location[i18n.language] || item.location.en}
            </MenuItem>
          ))}
        </TextField>
      )}

      {showReasonStep && !hideReasonStep && (
        <Stack>
          <Typography sx={styles.heading}>
            {t("reasonForVisitModal.selectReason")}
          </Typography>
          <RadioGroup
            key={location || "no-location"}
            value={reasonForVisit}
            onChange={(event) => onReasonForVisitChange(event.target.value)}
            sx={styles.reasonGroup}
          >
            {sortedUniqueTypes.map((reason) => {
              const labelText = getTranslatedReason(
                reason,
                appointmentReasons,
                i18n.language
              );

              return (
                <FormControlLabel
                  key={reason}
                  value={reason}
                  control={<Radio sx={styles.radioButtonChecked} />}
                  label={
                    <span>{highlightWord(labelText, highlightWords)}</span>
                  }
                />
              );
            })}
          </RadioGroup>
        </Stack>
      )}
    </>
  );
};
